<section>
  <kendo-grid [data]="outageScheduleGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="outageScheduleGridstate.sort"
              (sortChange)="outageScheduleGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="outageScheduleGridstate.take"
              [skip]="outageScheduleGridstate.skip"
              [columnMenu]="false"
              (pageChange)="outageScheduleGridPageChange($event)"
              (dataStateChange)="outageScheduleDataStateChange($event)"
              [filter]="outageScheduleGridstate.filter"
              [loading]="outageGridLoading">

    <kendo-grid-column field="outageDescription" title="{{outageSchedules.descriptionLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="startDate" title="{{outageSchedules.startDateLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="startTime" title="{{outageSchedules.startTimeLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="endDate" title="{{outageSchedules.endDateLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="endTime" title="{{outageSchedules.endTimeLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{outageSchedules.isActiveLbl}}" [width]="135" field="isActive">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="true">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-command-column title="{{outageSchedules.actionLbl}}" [width]="150" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                (click)="editOutageSchedule(dataItem)">
          <span class=" k-icon k-i-edit k-i-pencil"></span>
        </button>

        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>

      </ng-template>
    </kendo-grid-command-column>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="col-sm-12 center">
    <button (click)="toggleOutageScheduleDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
      Add Outage Schedule
    </button>
  </div>
</section>
<section class="dialogSection">
  <kendo-dialog title="Add Outage Schedule" *ngIf="outageScheduleDialog.opened" (close)="toggleOutageScheduleDialog()">
    <form [formGroup]="outageScheduleForm">
      <div class="row">
        <input type="hidden" formControlName="outageScheduleId" />
        <div class="col-sm-6">
          <div class="form-group">
            <label class="lblCls">
              {{outageSchedules.startDateLbl}} &amp; {{outageSchedules.startTimeLbl}} (CST)<span class="requiredField">*</span>
            </label>
            <kendo-datetimepicker class="kendoInput" formControlName="startDateTime"
                              placeholder="MM/DD/YYYY HH:mm"
                              format="MM/dd/yyyy HH:mm"
                              [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" [min]="convertTZ(outageSchedules.todayDate,'America/Chicago')" [ngClass]="{'borderRed':outageSchedules.isEmptyStartDate && outageSchedules.isSubmitted}" (blur)="validateOutageSchedulesForm()">
            </kendo-datetimepicker>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{outageSchedules.descriptionLbl}}
            </label>
            <input type="text" kendoTextBox formControlName="description" class="kendoInput" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{outageSchedules.isActiveLbl}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="lblCls">
              {{outageSchedules.endDateLbl}} &amp; {{outageSchedules.endTimeLbl}}(CST)<span class="requiredField">*</span>
            </label>
            <kendo-datetimepicker class="kendoInput" formControlName="endDateTime"
                              placeholder="MM/DD/YYYY HH:mm"
                              format="MM/dd/yyyy HH:mm"
                              [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" [min]="convertTZ(outageSchedules.todayDate,'America/Chicago')" [ngClass]="{'borderRed':outageSchedules.isEmptyEndDate && outageSchedules.isSubmitted}" (blur)="validateOutageSchedulesForm()">
            </kendo-datetimepicker>
            <span title="End Date should be greater than Start Date"
                  *ngIf="outageSchedules.isEndDateInValid" kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
        </div>
      </div>
      
      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleOutageScheduleDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveOutageSchedule()">
                Save<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.outageDescription }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
